import React from 'react';
import { styled } from '@compiled/react';

import { LoadableAfterPaint } from '@confluence/loadable';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EmptyTitleArea = styled.div<{ isTemplateEditor?: boolean }>({
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: (props) => (props.isTemplateEditor ? '87px' : '113px'),
});

export const TitleAreaContentComponents = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TitleAreaContentComponents" */ '../src/TitleAreaContentComponents.tsx'
			)
		).TitleAreaContentComponents,
	loading: (props) => <EmptyTitleArea isTemplateEditor={props.isTemplateEditor} />,
});

export const SmartCreateTitleAreaContentComponents = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SmartCreateTitleAreaContentComponents" */ '../src/SmartCreateTitleAreaContentComponents.tsx'
			)
		).SmartCreateTitleAreaContentComponents,
	loading: () => <EmptyTitleArea />,
});
